module.exports = __webpack_public_path__ + "Anthony.0d0e8e35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/mocks/Anthony.png
// module id = 2387
// module chunks = 0